import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_report_inputs_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { input_ids: string[], full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, label?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.input_ids)) {
      $missingRequiredInParams.push('\'input_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { input_ids?: string[], full_text_search?: string, $keys: string[] }): Promise<{ result?: { id?: string, label?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      input_ids: string[], full_text_search?: string    }) {
        if(isNil($inParams.input_ids)) {
          return true; 
        }
      return false;
    }
}
